import { useCallback, useEffect, useState } from "react";

const POLL_MS = 60_000; // refresh live count once a minute

/** Shared state hook consumed by the modal, ribbon, and nav chip.
 *  All three surface the same live seat count. */
export const useGClubStatus = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return;
    try {
      const r = await fetch(`${base}/api/g-club/status`);
      if (r.ok) {
        const data = await r.json();
        setStatus(data);
      }
    } catch {
      /* silent */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const id = window.setInterval(load, POLL_MS);
    const onVis = () => {
      if (document.visibilityState === "visible") load();
    };
    document.addEventListener("visibilitychange", onVis);
    return () => {
      window.clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [load]);

  return { status, loading, refresh: load };
};

export default useGClubStatus;
